"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.indexOnRelationRule = void 0;
exports.getMissingIndexOnRelation = getMissingIndexOnRelation;
const utils_1 = require("@azimutt/utils");
const database_1 = require("../../database");
const databaseUtils_1 = require("../../databaseUtils");
const rule_1 = require("../rule");
/**
 * Relations are often used on JOIN or WHERE clauses to fetch more data or limit rows.
 * It can be a good practice to add indexes on most relation columns.
 */
const ruleId = 'index-on-relation';
const ruleName = 'index on relation';
const ruleDescription = 'relation attributes with no index';
const CustomRuleConf = rule_1.RuleConf.extend({
    ignores: database_1.AttributesId.array().optional()
}).strict().describe('IndexOnRelationConf');
exports.indexOnRelationRule = {
    id: ruleId,
    name: ruleName,
    description: ruleDescription,
    conf: { level: rule_1.RuleLevel.enum.medium },
    zConf: CustomRuleConf,
    analyze(conf, now, db, queries, history, reference) {
        const refIgnores = reference.map(r => r.entity && Array.isArray(r.extra?.indexAttrs) ? { ...r.entity, attributes: r.extra.indexAttrs } : undefined).filter(utils_1.isNotUndefined);
        const ignores = refIgnores.concat(conf.ignores?.map(databaseUtils_1.attributesRefFromId) || []);
        const entities = (0, utils_1.indexBy)(db.entities || [], databaseUtils_1.entityToId);
        return (db.relations || [])
            .flatMap(r => getMissingIndexOnRelation(r, entities))
            .filter(idx => !ignores.some(i => (0, databaseUtils_1.attributesRefSame)(i, { ...idx.ref, attributes: idx.ref.attrs })))
            .map(i => ({
            ruleId,
            ruleName,
            ruleLevel: conf.level,
            message: `Create an index on ${(0, databaseUtils_1.attributesRefToId)({ ...i.ref, attributes: i.ref.attrs })} to improve ${(0, databaseUtils_1.relationToId)(i.relation)} relation.`,
            entity: (0, databaseUtils_1.relationLinkToEntityRef)(i.ref),
            attribute: i.ref.attrs[0],
            extra: { indexAttrs: i.ref.attrs, relation: i.relation }
        }));
    }
};
// same as frontend/src/PagesComponents/Organization_/Project_/Views/Modals/SchemaAnalysis/IndexOnForeignKeys.elm
function getMissingIndexOnRelation(relation, entities) {
    return [
        hasIndex(relation, relation.ref, entities),
        hasIndex(relation, relation.src, entities),
    ].filter(utils_1.isNotUndefined);
}
function hasIndex(relation, ref, entities) {
    const entity = entities[(0, databaseUtils_1.entityRefToId)(ref)];
    if (!entity)
        return undefined; // don't suggest new index if entity is not found
    if (matchIndex(entity.pk?.attrs || [], ref.attrs) || entity.indexes?.find(i => matchIndex(i.attrs, ref.attrs)) !== undefined) {
        return undefined;
    }
    else {
        return { relation, ref };
    }
}
function matchIndex(indexAttrs, attributes) {
    return attributes.every((a, i) => (0, databaseUtils_1.attributePathToId)(a) === (0, databaseUtils_1.attributePathToId)(indexAttrs[i] || []));
}
//# sourceMappingURL=indexOnRelation.js.map